module.exports = __webpack_public_path__ + "img/aletta-right.cc819381.gif";